<template>
  <div class="vselect">
    <el-dropdown @command="handleCommand" style="padding: 10px 15px">
      <span class="el-dropdown-link">
        {{ name }}
        <el-divider direction="vertical"></el-divider>
        <span class="btn">{{ lable ? lable : value ? value : "全部" }}</span>
      </span>
      <!-- id="dropdown_menu" -->
      <el-dropdown-menu
        style="max-height: 300px; overflow: auto"
        slot="dropdown"
      >
        <el-dropdown-item
          v-for="(item, i) in options"
          :command="item.dictValue + ',' + item.dictKey"
          :key="i"
        >
          {{ item.dictValue }}
        </el-dropdown-item>
        <el-dropdown-item v-if="options.length == 0" command="暂无数据">
          暂无数据
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "学科",
    },
    options: {
      type: Array,
      default: null,
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      lable: "",
    };
  },
  methods: {
    handleCommand(command) {
      console.log(command, "handleCommandxxx");
      if (command != "暂无数据") {
        this.lable = command.split(",")[0];
        const id = command.split(",")[1];
        this.$emit("emit", id);
      }
      // else if (command == '') {
      //   console.log("还原参数", "handleCommandxxx");
      //   this.lable = '';
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.vselect {
  // height: 50px;
  background: #ffffff;
  border-radius: 20px;
  margin-right: 15px;
  // padding-left: 12px;
  box-shadow: 0px 2px 8px rgba(15, 23, 65, 0.08);
  // padding: 35rpx;
  // display: inline-block;

  // .project-dropdown {
  //   //设置高度才能显示出滚动条 !important
  //   height: 300px;
  //   overflow: auto;
  // }
  // .project-dropdown::-webkit-scrollbar {
  //   width: 5px;
  //   height: 5px;
  //   background-color: #f5f5f5;
  // }
  // .project-dropdown::-webkit-scrollbar-track {
  //   //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  //   border-radius: 10px;
  //   background-color: #f5f5f5;
  // }

  .vselect-title {
    display: block;
  }

  >>> .el-select .el-input__inner {
    border: 1px solid transparent;
    margin-left: -5px;
  }

  .btn {
    cursor: pointer;
  }
}
</style>
// <style  lang="scss" scoped>
// #dropdown_menu /deep/ .-webkit-scrollbar {
//   width: 5px;
//   height: 5px;
//   background-color: #f5f5f5;
// }

// #dropdown_menu /deep/ .-webkit-scrollbar-track {
//   border-radius: 10px;
//   background-color: #f5f5f5;
// }
// </style>



// WEBPACK FOOTER //
// src/components/Vselect/index.vue